import type { ApiScopeId } from './ApiScopes';
import type { PolicyBaseWithId } from './PolicyBase';
import type { PolicyWithAttributeScopes } from './PolicyWithAttributeScopes';

export type PolicyWithApiScopes = PolicyBaseWithId & {
  apiScopeIds: ApiScopeId[];
  scopeType: 'apiScopes';
};

export const isPolicyWithApiScopes = (
  x: PolicyWithApiScopes | PolicyWithAttributeScopes | undefined,
): x is PolicyWithApiScopes => x?.scopeType === 'apiScopes';
